


















































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions, LanguageRow, UiLanguageItem } from '@/types'
import {
  CREATE_MASTER_DATA_WORK_LIST, DELETE_MASTER_DATA_WORK_LIST, EDIT_MASTER_DATA_WORK_LIST, FETCH_MASTER_DATA_WORK_LIST,
} from '@/store/action-types'
import ColorCellRenderer from '@/components/cell-renderer/ColorCellRenderer.vue'
import WorkEditorDialog from '@/components/master-data/WorkEditorDialog.vue'
import { QcqOperations, SnackbarStateEnum } from '@/types/enums'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { TranslateResult } from 'vue-i18n'
import { CreateMasterDataWorkPayload, EditMasterDataWorkPayload } from '@/types/payload'
import { GetArbeitenResponse, ResponseBase } from '@/types/service-response'
import { ValueGetterParams } from 'ag-grid-community'
import { Work } from '@/model/master-data/Work'

interface ComponentData {
  gridData: Work[]
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  operation: typeof QcqOperations
  openDialog: boolean
  currentSelectedRowId: number | null
  currentSelectedRowData: Work | undefined
  currentSelectedOperation: number
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  showDeleteDialog: boolean
  overlayNoRowsTemplate: string
  showSearchField: boolean
  search: string | null
}

export default Vue.extend({
  name: 'MasterDataWorkPage',

  components: {
    AgGridVue,
    WorkEditorDialog,
    DeleteDialog
  },

  data (): ComponentData {
    return {
      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('qcqQualificationPage.code'), field: 'code', width: 150 },
          { headerName: this.$t('qcqQualificationPage.description'), field: 'descriptionList', width: 300,
            valueGetter: (params: ValueGetterParams) => {
            //@ts-ignore
              return params.data.getDescriptionLabel
            }
          },
          { headerName: this.$t('color'), field: 'color', cellRenderer: 'colorRenderer' }
        ]
      },

      gridFrameworkComponents: {
        colorRenderer: ColorCellRenderer
      },

      operation: QcqOperations,
      openDialog: false,
      currentSelectedRowId: null,
      currentSelectedOperation: QcqOperations.ADD,
      currentSelectedRowData: undefined,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      showDeleteDialog: false,
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      showSearchField: false,
      search: null
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedUiLanguage (): UiLanguageItem {
      return this.$store.state.selectedUiLanguage
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isSearchEnabled (): boolean {
      return this.gridData.length > 0
    },

    filteredGridData (): Work[] {
      if(this.search) {
        return this.gridData.filter((item: Work) => {
          return item.getDescriptionLabel ? item.getDescriptionLabel.toLowerCase().includes(this.search!.toLowerCase()) : false
        })
      } else {
        return this.gridData
      }
    }
  },

  methods: {
    showDialog (operation: number): void {
      this.currentSelectedOperation = operation

      if (this.currentSelectedOperation === QcqOperations.ADD) {
        this.currentSelectedRowData = undefined
      }

      this.openDialog = true
    },

    odDeleteButtonClick () {
      if (this.currentSelectedRowData && !this.currentSelectedRowData.isErasable) {
        this.messageSnackbar = this.$t('masterData.work.theWorkCouldNotBeDeleted').toString().replace('%s', `"${this.currentSelectedRowData.getDescriptionLabel}"`)
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } else {
        this.showDeleteDialog = true
      }
    },

    closeDialog (): void {
      this.openDialog = false
      this.showDeleteDialog = false
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    async onDeleteDialogSave (): Promise<void> {
      try {
        const response: ResponseBase = await this.$store.dispatch(DELETE_MASTER_DATA_WORK_LIST, this.currentSelectedRowId)
        if(response && !response.IsError) {
          this.showDeleteDialog = false
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.currentSelectedRowId = null
          this.currentSelectedRowData = undefined
          this.fetchWorkList()
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    saveDialog (data: { rows: Array<LanguageRow>, color: string, code: string }): void {
      if(this.currentSelectedOperation === QcqOperations.ADD) {
        const payload: CreateMasterDataWorkPayload = {
          Code: data.code,
          Farbe: data.color,
          Items: data.rows.map((item: LanguageRow) => {
            return {
              Sprache: item.code,
              Bezeichnung: item.description
            }
          })
        }
        this.createWork(payload)
      } else if(this.currentSelectedOperation === QcqOperations.EDIT) {
        const payload: EditMasterDataWorkPayload = {
          Item: {
            ID: this.currentSelectedRowId!,
            Code: data.code,
            Farbe: data.color,
            Bezeichnungen: data.rows.map((item: LanguageRow) => {
              return {
                ID: item.id!,
                Sprache: item.code,
                Arbeit: this.currentSelectedRowId!,
                Bezeichnung: item.description
              }
            })
          }
        }
        this.updateWork(payload)
      }
    },

    async createWork (payload: CreateMasterDataWorkPayload): Promise<void> {
      this.loading = true
      try {
        const response: ResponseBase = await this.$store.dispatch(CREATE_MASTER_DATA_WORK_LIST, payload)
        if(response && !response.IsError) {
          this.loading = false
          this.openDialog = false
          this.messageSnackbar = response.Result ? response.Result : this.$t('masterData.work.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.currentSelectedRowId = null
          this.currentSelectedRowData = undefined
          this.fetchWorkList()
        } else {
          this.loading = false
          this.messageSnackbar = response.Result ? response.Result : this.$t('masterData.work.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.loading = false
        this.messageSnackbar = this.$t('masterData.work.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async updateWork (payload: EditMasterDataWorkPayload): Promise<void> {
      this.loading = true
      try {
        const response: ResponseBase = await this.$store.dispatch(EDIT_MASTER_DATA_WORK_LIST, payload)
        if(response && !response.IsError) {
          this.loading = false
          this.openDialog = false
          this.messageSnackbar = response.Result ? response.Result : this.$t('masterData.work.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.currentSelectedRowId = null
          this.currentSelectedRowData = undefined
          this.fetchWorkList()
        } else {
          this.loading = false
          this.messageSnackbar = response.Result ? response.Result : this.$t('masterData.work.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.loading = false
        this.messageSnackbar = this.$t('masterData.work.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onRowDataChanged () {
      //@ts-ignore
      this.gridOptions.api.sizeColumnsToFit()
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedRowData = this.gridData.find((item: Work) => item.id === this.currentSelectedRowId!)
    },

    onRowDoubleClicked (params: any) {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedRowData = this.gridData.find((item: Work) => item.id === this.currentSelectedRowId!)
      this.showDialog(QcqOperations.EDIT)
    },

    onSearchButtonClick (): void {
      this.showSearchField = !this.showSearchField
      if(!this.showSearchField) {
        this.search = null
      }
    },

    async fetchWorkList (): Promise<void> {
      try {
        const response: GetArbeitenResponse = await this.$store.dispatch(FETCH_MASTER_DATA_WORK_LIST)
        if(response && !response.IsError) {
          this.gridData = Work.createListFromResponse(response.Arbeiten)
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  async mounted () {
    this.fetchWorkList()
  }
})
